import React, { useEffect } from 'react';
import './MobileComposerLayout.css';

interface MobileComposerLayoutProps {
  children: React.ReactNode;
}

/**
 * Root wrapper component for mobile layout that manages viewport structure
 * and prevents page scrolling.
 * 
 * Requirements: 2.1, 2.2, 2.3, 12.1, 12.2, 12.3, 16.2, 16.5
 */
export const MobileComposerLayout: React.FC<MobileComposerLayoutProps> = ({ children }) => {
  useEffect(() => {
    // Prevent body scrolling when mobile layout is active
    const originalOverflow = document.body.style.overflow;
    const originalPosition = document.body.style.position;
    
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.height = '100%';
    
    // Cleanup: restore original body styles when component unmounts
    return () => {
      document.body.style.overflow = originalOverflow;
      document.body.style.position = originalPosition;
      document.body.style.width = '';
      document.body.style.height = '';
    };
  }, []);

  return (
    <div className="mobile-composer-layout" role="main" aria-label="Mobile composer interface">
      {/* ARIA live region for screen reader announcements - Requirement 16.5 */}
      <div
        id="mobile-announcer"
        role="status"
        aria-live="polite"
        aria-atomic="true"
        className="sr-only"
        style={{
          position: 'absolute',
          left: '-10000px',
          width: '1px',
          height: '1px',
          overflow: 'hidden',
        }}
      />
      {children}
    </div>
  );
};
